import { type FavoriteComponentProps, useFavoriteApiContext } from '@/context/FavoriteApiProvider';

export const FavoriteButton = ({ itemId, variant, isOpen, buttonClass }: FavoriteComponentProps) => {
    const { FavoriteComponent } = useFavoriteApiContext();

    return FavoriteComponent ? (
        <FavoriteComponent
            data-testid="favoriteButton"
            itemType="Ad"
            variant={variant}
            itemId={itemId}
            isOpen={isOpen}
            buttonClass={buttonClass}
        />
    ) : null;
};
